import React from 'react';
import { arrayBuilderYesNoUI } from 'platform/forms-system/src/js/web-component-patterns';
import get from 'platform/utilities/data/get';

import fullSchema from '../../../schema';
import { vaMedicalRecordsOptions } from './options';

const { arrayPath } = vaMedicalRecordsOptions;

/**
 * Shown in place of the summary cards (e.g. after deleting the last
 * remaining facility). Placed as its own schema field — rather than in the
 * summary page's title/description text overrides — so it renders after the
 * page's alerts/cards block instead of above it.
 */
const NoVaRecordsMessage = () => (
  <p>There are no records from VA providers associated with this claim.</p>
);

export default {
  uiSchema: {
    'view:noVaRecordsMessage': {
      'ui:description': NoVaRecordsMessage,
      'ui:options': {
        hideIf: formData => !!get(arrayPath, formData)?.length,
      },
    },
    'view:hasVaTreatmentFacilities': arrayBuilderYesNoUI(
      vaMedicalRecordsOptions,
      // Reachable with no cards present: the intro page's `onNavForward`
      // only skips the summary on the way in when the loop is empty, so
      // deleting the last facility (or navigating back) still lands here.
      {
        title: 'Do you have a VA or military health facility to add?',
        errorMessages: {
          required:
            'Select yes if you have a VA or military health facility to add',
        },
      },
      {
        title: 'Do you have another VA or military health facility to add?',
        errorMessages: {
          required:
            'Select yes if you have another VA or military health facility to add',
        },
      },
    ),
  },
  schema: {
    type: 'object',
    required: ['view:hasVaTreatmentFacilities'],
    properties: {
      'view:noVaRecordsMessage': { type: 'object', properties: {} },
      'view:hasVaTreatmentFacilities':
        fullSchema.properties['view:hasVaTreatmentFacilities'],
    },
  },
};
